import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgBusinessOutlined(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0.000732422C9.51472 0.000732422 7.5 2.01545 7.5 4.50073V5.00078H4C2.89543 5.00078 2 5.89621 2 7.00078V19.0008C2 20.1053 2.89543 21.0008 4 21.0008H20C21.1046 21.0008 22 20.1053 22 19.0008V7.00078C22 5.89621 21.1046 5.00078 20 5.00078H16.5V4.50073C16.5 2.01545 14.4853 0.000732422 12 0.000732422ZM14.5 5.00078V4.50073C14.5 3.12002 13.3807 2.00073 12 2.00073C10.6193 2.00073 9.5 3.12002 9.5 4.50073V5.00078H14.5ZM4 19.0008V13.0121C6.65649 13.9142 9.32432 14.369 12 14.369C14.6758 14.369 17.3436 13.9141 20 13.012V19.0008H4ZM4 7.00078V10.8905C6.67916 11.8794 9.34433 12.369 12 12.369C14.6558 12.369 17.3209 11.8793 20 10.8903V7.00078H4Z", fill: "currentColor" })));
}
export default SvgBusinessOutlined;
